import { bindable, BindingMode } from "aurelia";

import { IMtLabeledToggleButton } from "@/interfaces";

export class MtLabeledToggle {
  bound() {
    // assign the desired option as initially checked
    this.checked = this.buttons[this.checkedIndex];
  }

  matcherFunc = (a: IMtLabeledToggleButton, b: IMtLabeledToggleButton) => a.id === b.id;

  // when the checkedIndex prop changes due store update
  // update the checked atrribute also
  checkedIndexChanged() {
    this.checked = this.buttons[this.checkedIndex];
  }
  // bound callback
  @bindable onToggled: ({ checked }: { checked: number }) => void;
  // bound initial checked radio index
  @bindable({ mode: BindingMode.twoWay }) checkedIndex = 0;
  // bound labels for options
  @bindable buttons: IMtLabeledToggleButton[];
  // modal item for checked option
  checked: IMtLabeledToggleButton;

  // when div is clicked, the input associated with the label must be
  // unchecked to prompt an update
  onClick(event: PointerEvent) {
    const target = event.target as HTMLLabelElement;
    const control = target.control as HTMLInputElement;
    if (!control) return;
    if (!control.checked) {
      this.checkedIndex = this.buttons.findIndex((btn) => btn.id === control.id);
      // If exists, run callback
      if (this.onToggled) this.onToggled({ checked: this.checkedIndex });
    }
  }
}
